import { WidgetType } from '../../../shared/constants/widget';

export const DASHBOARD_LAYOUT_EXCLUDED_PATHS = ['/admin', '/resourcehub'];

// TODO: better names, reload flash issue
export const FEATURED_DOWNLOADS = [
  {
    title: 'HOW_ORG_DIMS_WORK',
    subTitle: 'HOW_ORG_DIMS_WORK_DESC',
    link: 'https://intellect.co/wp-content/uploads/2025/03/Dimensions-Benchmarking.pdf',
    color: '#EAF2D7',
    instrumentation: 'glossary',
  },
  {
    title: 'QUICK_GUIDE_DEFINITIONS',
    subTitle: 'QUICK_GUIDE_DEFINITIONS_DESC',
    link: 'https://intellect.co/wp-content/uploads/2024/07/Organisational-and-Personal-Dimensions-Descriptions.pdf',
    color: '#FFEEDD',
    instrumentation: 'dim_def',
  },
  {
    title: 'HOW_EMP_TAKE_PI_QUIZ',
    subTitle: 'HOW_EMP_TAKE_PI_QUIZ_DESC',
    link: 'https://intellect.co/wp-content/uploads/2024/07/Dimensions-explainer.pdf',
    color: '#D7E3FC',
    instrumentation: 'pi_quiz_details',
  },
];

export const WIDGETS_LAYOUT_SIDEBAR_OFFSETS = {
  mobile: 0,
  collapsed: 82,
  expanded: 240,
};

export const WIDGETS_LAYOUT_MARGIN_TOP = '72px';
export const WIDGETS_LAYOUT_PADDING_LEFT = {
  mobile: '1rem',
  desktop: '1.5rem',
};

export enum WIDGET_HEIGHT {
  xs = 150,
  sm = 250,
  md = 400,
  lg = 550,
  xl = 700,
}

export const WIDGET_TYPE_HEIGHT_MAP: Record<WidgetType, number> = {
  [WidgetType.BAR_CHART]: WIDGET_HEIGHT.md,
  [WidgetType.STACKED_BAR_CHART]: WIDGET_HEIGHT.md,
  [WidgetType.BAR_CHART_WITH_TREND]: WIDGET_HEIGHT.md,
  [WidgetType.BENCHMARK_LINE_CHART]: WIDGET_HEIGHT.md,
  [WidgetType.TABLE]: WIDGET_HEIGHT.lg,
  [WidgetType.FLASH_CARD]: WIDGET_HEIGHT.sm,
  [WidgetType.FEEDBACK_BANNER]: WIDGET_HEIGHT.sm,
  [WidgetType.ICON_CARDS]: WIDGET_HEIGHT.sm,
  [WidgetType.BENCHMARK_SCORE_CARD]: WIDGET_HEIGHT.sm,
  [WidgetType.SCORE_INFO_CARD]: WIDGET_HEIGHT.sm,
  [WidgetType.MULTI_LEVEL_BAR_CHART]: WIDGET_HEIGHT.md,
  [WidgetType.HERO_DIMENSION]: WIDGET_HEIGHT.sm,
  [WidgetType.DIMENSION_SCORE_CARD]: WIDGET_HEIGHT.sm,
  [WidgetType.RECOMMENDATIONS_CARD]: WIDGET_HEIGHT.sm,
  [WidgetType.BENCHMARK_PROGRESS_BAR]: WIDGET_HEIGHT.sm,
  [WidgetType.PIE_CHART]: WIDGET_HEIGHT.md,
  [WidgetType.PIE_CHART_CLUSTER]: WIDGET_HEIGHT.md,
};

// the headers for some widgets are implemented inside the widget component (e.g. BenchmarkScoreCard) instead of the WidgetRenderer wrapper.
// wrapper: WidgetRenderer implements the header (title, subtitle) for the widget
// self: the widget component itself implements the header, so WidgetRenderer will not render title and subtitle for this widget
export enum HEADER_IMPLEMENTATION_OWNERSHIP {
  Wrapper,
  Self,
}
